module.exports = __webpack_public_path__ + "fonts/SegoeUI-Bold.ce4ba28.woff2";